import {SnippetsOutlined} from '@ant-design/icons'
import Commonview from '../../../pages/common_view';
import TemplateManage from "../../../pages/call_card/template_manage";
import SignatureManage from "../../../pages/call_card/signature_manage";
import BillManage from "../../../pages/call_card/bill_manage";

const CallCardRouter = [
    {
        path: '/CallCard',
        element: <Commonview/>,
        meta: {title: '来电名片', icon: <SnippetsOutlined />},
        children: [
            {
                path: '/CallCard/Template',
                meta: {title: '模版管理', key: 'calling_card_template_management'},
                element: <TemplateManage/>,
            },
            {
                path: '/CallCard/Signature',
                meta: {title: '签名管理', key: 'calling_card_signature_management'},
                element: <SignatureManage/>,
            },
            {
                path: '/CallCard/billManage',
                meta: {title: '账单接收', key: 'calling_card_bill_management'},
                element: <BillManage/>,
            },
        ]
    }
]

export default CallCardRouter
